module.exports = __webpack_public_path__ + "media/images/icons/logo-new-70d9720e9b74f88034006fa394638e2c.svg";